import { ToastNotify } from 'reactComponents/ToastNotify/ToastNotify';

import copyToClipboard from './copyToClipboard';

/**
 * @param {string} string
 * @returns {boolean}
 */
export function copyStringToClipboard(string, notificationText = '') {
    const target = document.createElement('textarea');

    target.value = string;

    document.body.appendChild(target);

    const result = copyToClipboard(target);

    document.body.removeChild(target);

    if (notificationText) {
        ToastNotify.success(notificationText);
    }

    return result;
}
